const paralaxContainer = document.getElementById('paralax-container');

const image_1 = document.querySelector('.paralax-effect__image-1');
const image_2 = document.querySelector('.paralax-effect__image-2');
const image_3 = document.querySelector('.paralax-effect__image-3');
const image_4 = document.querySelector('.paralax-effect__image-4');

const depth_1 = image_1.getAttribute('data-depth');
const depth_2 = image_2.getAttribute('data-depth');
const depth_3 = image_3.getAttribute('data-depth');
const depth_4 = image_4.getAttribute('data-depth');

const speed_1 = image_1.getAttribute('data-speed');
const speed_2 = image_2.getAttribute('data-speed');
const speed_3 = image_3.getAttribute('data-speed');
const speed_4 = image_4.getAttribute('data-speed');

function activeParalaxEffect() {
    const rect = paralaxContainer.getBoundingClientRect();
    if (rect.top <=600) {
        const scrollTop = rect.top;

        const translateY_1 = scrollTop * speed_1 / depth_1 * 1.1;
        image_1.style.cssText = `
            display: block;
            transform: translateY(${translateY_1}px);
        `;

        const translateY_2 = scrollTop * speed_2 / depth_2 * 1.5;
        image_2.style.cssText = `
            display: block;
            transform: translateY(${translateY_2}px);
        `;

        const translateY_3 = scrollTop * speed_3 / depth_3 * 1.6;
        image_3.style.cssText = `
            display: block;
            transform: translateY(${translateY_3}px);
        `;

        const translateY_4 = scrollTop * speed_4 / depth_4 * 1.3;
        image_4.style.cssText = `
            display: block;
            transform: translateY(${translateY_4}px);
        `;
    }
}

window.addEventListener('scroll', activeParalaxEffect);
activeParalaxEffect();
